import React,{ useEffect,useState } from 'react';
import Panel from "../Panel";
import DataReactTable from "./DataReactTable";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {connect} from "react-redux";
import ModelSubmissions from '../../../Models/Submissions';
import {Link, useHistory} from "react-router-dom";
import {faExternalLinkAlt, faEye, faHotel, faPen} from "@fortawesome/free-solid-svg-icons";
import Tooltip from "rc-tooltip";
import DataTable from "../DataTable";

const SubmissionsTable = ({ dispatch, venues, submissions,title, limit}) => {

    const [isTableLoaded,setLoaded] = useState(false);
    const [submission,setSelectedSubmission] = useState(null);
    const um = new ModelSubmissions();
    const history = useHistory();

    const redirect = (link) =>{
        history.push(link);
    };

    useEffect(()=>{
        setLoaded(false);
        if(typeof submissions !== 'undefined' || submissions!==null){
            setLoaded(true);
        }
    },[submissions]);

    const columns =[
        {
            width: 300,
            Header: "Edit",
            Cell: ({ cell }) => {
                 // debugger
                return (
                    <>
                        <Tooltip placement="top" overlay={"View/Edit"}>
                            <button className={ "btn btn-info btn-sm m-0 mr-2 mt-1 pt-1 pb-1 pl-2 pr-1"} onClick={() => redirect("/s/"+cell.row.original.qr_id)}>
                                <FontAwesomeIcon icon={faEye}/>
                            </button>
                        </Tooltip>
                        <Tooltip placement="top" overlay={"View in New Tab"}>
                            <Link
                                to={"/s/" + cell.row.original.qr_id}
                                target="_blank"
                            >
                                <button type={"button"} className={ "btn btn-info btn-sm m-0 mr-2 mt-1 pt-1 pb-1 pl-2 pr-1"}>
                                    <FontAwesomeIcon icon={faExternalLinkAlt} />
                                </button>
                            </Link>
                        </Tooltip>
                        <Tooltip placement="top" overlay={"Open Venue in New Tab"}>
                            <Link
                                to={"/venue/" + cell.row.original.v_id}
                                target="_blank"
                            >
                                <button type={"button"} className={ "btn btn-info btn-sm m-0 mr-2 mt-1 pt-1 pb-1 pl-2 pr-1"}>
                                    <FontAwesomeIcon icon={faHotel} />
                                </button>
                            </Link>
                        </Tooltip>
                    </>
                )
            }
        },{
            Header: 'ID',
            accessor: 'qr_id',
            width: 100
        },{
            width: 300,
            Header: "Venue",
            accessor: "v_name"
        },{
            Header: 'Name',
            accessor: 'name',
            width: 150
        },{
            Header: 'Budget',
            accessor: 'qr_event_budget_number'
        },{
            Header: '# of People',
            accessor: 'qr_num_of_people'
        },{
            Header: 'Event Date',
            accessor: 'qr_event_date'
        },{
            Header: 'Event Type',
            accessor: 'et_name'
        },{
            Header: 'Email',
            accessor: 'qr_email'
        },{
            Header: 'Created Date',
            accessor: 'qr_created_date'
        },{
            Header: 'Allow Other Venue Alts',
            accessor: 'qr_allow_other_venue_options'
        }
    ];

    const tableStructure= {
        tableHeaderData: columns
    };

    return (

        <Panel xl={12} lg={12} md={12} title={title??"Submissions"} subhead="Table of the latest submissions">
            <div>
                <DataTable columns={columns} endpoint={"/s/getSubmissionsV2"}/>
            </div>
        </Panel>

    );
};

export default connect(state => ({
    venues:state.venues.venues,
    submissions:state.submissions.submissions
}))(SubmissionsTable);
